<template>
  <div v-if="post_fetched" class="post">
    <h1
      v-html="post.title"
      style="font-family: Noto Sans; font-weight: bold"
    ></h1>
    <div class="status" style="font-family: Noto Sans">
      <div style="display: flex; align-items: center; width: fit-content">
        <Avatar height="25" />
        <div style="font-weight: bold; margin-left: 5px; margin-right: 5px">
          {{ post.author }}
        </div>
        /
        <div style="margin-left: 5px; margin-right: 5px">
          {{ moment(post.date).format("LL") }}
        </div>
      </div>
      <div style="margin-left: 5px; margin-right: 5px; font-weight: bold">
        {{ post.time }} • {{ post.views }} views
      </div>
    </div>
    <br />
    <br />
    <p
      v-html="post.desc"
      style="
        font-family: Noto Sans;
        font-size: 1.1rem;
        font-weight: bold;
        border-left: 5px solid rgb(255, 174, 0);
        padding-left: 15px;
        overflow-wrap: break-word;
        text-align: left;
      "
    ></p>
    <br />
    <template v-for="block in post.data.blocks">
      <div v-if="block.type === 'header'" v-bind:key="block.id">
        <br />
        <div
          :class="'h' + block.data.level.toString()"
          style="font-family: Noto Sans; font-weight: bold"
          v-html="block.data.text"
        ></div>
        <br />
      </div>
      <p
        style="font-size: 1.2rem"
        v-else-if="block.type === 'paragraph'"
        v-bind:key="block.id"
        v-html="block.data.text"
      ></p>
      <Prism
        style="border-radius: 15px"
        v-else-if="block.type === 'code'"
        v-bind:key="block.id"
        language="javascript"
        >{{ block.data.code }}</Prism
      >
      <div
        v-else-if="block.type === 'simpleImage'"
        v-bind:key="block.id"
        style="width: 100%"
      >
        <img
          :src="block.data.url"
          :alt="block.data.caption"
          :class="{
            with_border: block.data.withBorder,
            strech_image: block.data.stretched,
            with_background: block.data.withBackground,
          }"
          style="max-width: 100%"
        />
        <div style="color: #444444; text-align: center">
          {{ block.data.caption }}
        </div>
        <br />
      </div>
      <div v-else v-bind:key="block.id"></div>
    </template>
  </div>
  <div v-else style="margin: auto; width: fit-content">
    <div class="spinner-grow text-secondary">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>
<style>
.post {
  color: black;
  font-family: Outfit;
  padding: 10px;
}
.status {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  color: #333333;
}
@media only screen and (max-width: 600px) {
  .status {
    flex-direction: column;
  }
}
.inline-code {
  background: rgba(250, 239, 240, 0.78);
  color: #b44437;
  padding: 3px 4px;
  border-radius: 4px;
  margin: 0 1px;
  font-family: inherit;
  font-size: 0.86em;
  font-weight: 500;
  letter-spacing: 0.3px;
}
.with_border {
  border: 1px solid #ccc;
  border-radius: 10px;
}
.strech_image {
  width: 100%;
}
.with_background {
  width: fit-content;
  margin: auto;
  display: block;
}
</style>
<script>
import { getDatabase, ref, onValue, update } from "firebase/database";
import moment from "moment";
import Prism from "vue-prism-component";
import Avatar from "../components/Avatar.vue";
export default {
  name: "Post",
  components: {
    Prism,
    Avatar,
  },
  data() {
    return {
      post: {},
      post_fetched: false,
    };
  },
  methods: {
    moment,
  },
  created() {
    const db = getDatabase();
    const Ref = ref(db, "blog/posts/" + this.$route.params.id);
    onValue(
      Ref,
      (snapshot) => {
        var postarray = snapshot.val();
        if (moment().diff(snapshot.val().date, "days") <= 5) {
          postarray.Ago = true;
        } else {
          postarray.Ago = false;
        }
        this.post = postarray;
        this.post_fetched = true;
        const views = this.post.views + 1;
        update(ref(db, "blog/posts/" + this.post.id), { views: views });
      },
      {
        onlyOnce: true,
      }
    );
  },
};
</script>
